module.exports = __webpack_public_path__ + "static/img/senceIcon3.9f2d157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/senceIcon3.png
// module id = Ts4d
// module chunks = 1